import React, { Fragment } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import DotIcon from '@material-ui/icons/Lens';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import Typography from '@material-ui/core/Typography';

import style from './dockOverloadCommon.module.css';

const styles = (theme: Theme ) =>

  createStyles({
    formControlLabel: {
      marginRight: 0,
      marginLeft: 0
    },
    gray: {
      color: 'lightgray'
    },
    red: {
      color: 'red'
    },
    green: {
      color: 'green'
    },
    orange: {
      color: 'orange'
    },
  });

interface DockOverloadCommonProps { 
  classes: any;
  forInfo: boolean;
  selectedValue: number;
  handleChangeSelectedValue: (event: any) => void;
  fontSizeIcon: number;
  fontSizeLabel: number;
  padding: number;
  work: any;
};

const dockOverloadCommon = (props: DockOverloadCommonProps) => {

  const { classes } = props;

  const radioRange: Array<number> = Array.from( { length: 24 }, (v, k) => k + 1 );
  const check: number = ( JSON.stringify(props.work) === '{}' ) ? -1 : props.selectedValue;
  const radioOptions: Array<JSX.Element> = radioRange.map((item: number, index: number) => {

    let classNameRadio: string = '';
    let disabled: boolean = false;
    let label: string = style.label;

    if (!props.work.hasOwnProperty(item)) {

      classNameRadio = classes.gray;
      label = style.labelDisabled;
      disabled = true;

    } else {

      if (props.work[item]> 0.6) {

        classNameRadio = classes.red;

      } else if (props.work[item]<= 0.6 && props.work[item]>0.3) {

        classNameRadio = classes.orange;

      } else {

        classNameRadio = classes.green;
      };
    };

    if (props.forInfo) {
      return (
        <div key={ index }>
          <div className={ label }>{ item }</div>
          <div className={ classNameRadio }>
            <DotIcon fontSize='small' />
          </div>
        </div>
      );
    };

    return(

      <div  key={ index } className={style.formControlWrapper }>
        <FormControlLabel  
          labelPlacement="top" 
          label={<Typography style={{fontSize: props.fontSizeLabel}}>{ item }</Typography>}
          className={ classes.formControlLabel }
          control={
            <Radio
              checked={ check === item }
              disabled={ disabled }
              className={ classNameRadio }
              style={{ padding: props.padding }}
              onChange={ props.handleChangeSelectedValue }
              value={ item }
              name='radio-button'
              icon={ <DotIcon style={{ fontSize: props.fontSizeIcon }} /> }
              checkedIcon={ <RadioButtonCheckedIcon style={{fontSize: props.fontSizeIcon}} color='primary' /> }
            />
          }
        />
      </div>
    )
  });

  return (
    <Fragment>
      { radioOptions }
    </Fragment>
  )
};

export default withStyles(styles)(dockOverloadCommon);
